<template>

    <bar :chart-data="chartData" :chart-options="chartOptions"></bar>

</template>

<script>

import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'


ChartJS.register( Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale )


export default {
    components: {
        Bar,
    },

    props: {
        dataset: {
            type: Object,
            required: true,
        },

        label: {
            type: String,
            required: true,
        },
    },


    computed: {
        chartData: function () {
            const labels = Object.keys( this.$props.dataset )
            const label = this.$props.label
            const data = Object.values( this.$props.dataset )

            return {
                labels,
                datasets: [ {
                    label,
                    data
                } ]
            }
        }
    },

    data() {
        return {
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                barThickness: 10,
                hoverBackgroundColor: '#003c61',
            }
        }
    }
}

</script>
